import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  doc,
  query,
  where,
  getDocs,
  collection,
  getFirestore,
  runTransaction,
} from "firebase/firestore";
import { getAnalytics, logEvent as fbLogEvent } from "firebase/analytics";
import { useEffect, useState } from "react";
import { useQuery, useQueryClient } from "react-query";

const prodConfig = {
  apiKey: "AIzaSyC2FQY3LPgh9bXifCONhmAi_ED-hJXm9Ng",
  authDomain: "spi-production.firebaseapp.com",
  projectId: "spi-production",
  storageBucket: "spi-production.appspot.com",
  messagingSenderId: "432829893197",
  appId: "1:432829893197:web:2fa6b11b288c032aacaa04",
  measurementId: "G-QQJ2PVCJSF",
};

const qaConfig = {
  apiKey: "AIzaSyBQBMVcKJebSySH23D8luZ_p3oYeNUZanY",
  authDomain: "spi-qa.firebaseapp.com",
  projectId: "spi-qa",
  storageBucket: "spi-qa.appspot.com",
  messagingSenderId: "629261389554",
  appId: "1:629261389554:web:7c8dde58aa3e1548730a6b",
  measurementId: "G-VJ2Q8BGZ61",
};

let firebase;

if (typeof window !== "undefined") {
  firebase = initializeApp(prodConfig);
}

const auth = getAuth(firebase);
auth.useDeviceLanguage();
export { auth };

export const analytics = getAnalytics(firebase);
export const logEvent = (...args) => fbLogEvent(analytics, ...args);

export const db = getFirestore(firebase);
export const users = collection(db, "users");
export const stats = collection(db, "stats");

export const addUser = async (data) => {
  return runTransaction(db, async (transaction) => {
    const userRef = doc(users);
    const statsRef = doc(stats, "stats");
    const statsSnapshot = await transaction.get(statsRef);
    transaction.set(userRef, data);
    transaction.update(statsRef, {
      [data.usage]: (statsSnapshot.data()[data.usage] || 0) + 1,
    });
  });
};

export const getUserByEmail = async (email) => {
  const q = query(users, where("email", "==", email));
  const document = await getDocs(q);
  return document.docs?.[0]?.data();
};

// useAuthUser from react-query-firebase doesn't seem to retrigger correctly
// Using a custom implementation for now
export const useAuthUser = (key = "user", options = {}) => {
  const [enabled, setEnabled] = useState(true);
  const [initialLoading, setInitialLoading] = useState(true);
  const queryClient = useQueryClient();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setInitialLoading(false);
      setEnabled(!!user);
      if (!user) {
        queryClient.setQueryData(key, () => undefined);
        queryClient.removeQueries(key, () => undefined);
      } else {
        queryClient.invalidateQueries(key, {
          refetchActive: true,
          refetchInactive: true,
        });
      }
    });
    return () => unsubscribe();
  }, [key, queryClient]);

  const query = useQuery(key, () => auth.currentUser, {
    ...options,
    enabled,
  });

  return {
    ...query,
    isLoading: initialLoading || query.isLoading,
  };
};
